import React, { Component } from "react";
import "./App.css";

import * as firebase from "firebase";
import { Tabs, Tab } from "react-bootstrap";
import { createSelector } from "reselect";

import Header from "./Header";
import FoodList from "./FoodList";
import RewardFooter from "./RewardFooter";

const fbconfig = {
  apiKey: "AIzaSyDzuWfhNrV0EdRyNF1EMRY1XpWPoqp09vU",
  authDomain: "drdog-588c6.firebaseapp.com",
  databaseURL: "https://drdog-588c6.firebaseio.com",
  storageBucket: "drdog-588c6.appspot.com",
  messagingSenderId: "655578372233",
};
firebase.initializeApp(fbconfig);

const foodsSelector = createSelector(
  state => state,
  foods => {
    console.log("transforming foods");
    return Object.keys(foods)
      .sort()
      .map(name => {
        const food = foods[name];
        return {
          ...food,
          ...{
            name,
            isNew:
              food.answer.indexOf("I'm not sure if dogs can eat") !== -1 ||
              food.answer.indexOf("I'm not sure if dogs can have") !== -1,
          },
        };
      });
  }
);

const unansweredSelector = createSelector(
  state => state,
  foods => foods.filter(food => food.isNew)
);

class App extends Component {
  state = {
    foods: {},
    user: null,
    activeTab: "all",
  };

  constructor() {
    super();

    this.rootRef = firebase
      .database()
      .ref()
      .child("food");

    firebase.auth().onAuthStateChanged(user => {
      this.setState({ user });
    });
  }

  componentDidMount() {
    // const rootRef = ;
    // const newRef = firebase.database().ref().child('food');

    // only on initial seed
    this.rootRef.on("value", snap => {
      if (Object.getOwnPropertyNames(this.state.foods).length === 0) {
        console.dir(snap.val());
        this.setState({
          foods: snap.val(),
        });
      }
    });

    // don't update unless it's been initially seeded by `value`
    this.rootRef.on("child_added", snap => {
      // newRef.child(snap.key).set({answer: snap.val()});

      if (Object.getOwnPropertyNames(this.state.foods).length !== 0) {
        const foods = { ...this.state.foods };
        foods[snap.key] = snap.val();
        this.setState({
          foods: foods,
        });
      }
    });

    this.rootRef.on("child_changed", snap => {
      const foods = { ...this.state.foods };
      foods[snap.key] = snap.val();
      this.setState({
        foods: foods,
      });
    });

    // child_removed
  }

  updateFood = (food, answer) => {
    // console.log("updating:");
    // console.dir({ food, answer });
    // const rootRef = firebase.database().ref().child('food');
    // this.rootRef.child(food).child('answer').set(answer);
    // ref.set(description);
    this.rootRef.child(food).update({
      answer,
      author: this.state.user.uid,
      updatedAt: +new Date(),
    });
  };

  render() {
    const { user, foods, activeTab } = this.state;

    let filteredFoods = foodsSelector(foods);

    if (activeTab === "unanswered") {
      filteredFoods = unansweredSelector(filteredFoods);
    }

    return (
      <div className="App">
        <Header firebase={firebase} user={user} />
        <div className="container">
          <div className="row">
            <Tabs
              activeKey={activeTab}
              onSelect={activeTab => this.setState({ activeTab })}
              id="visibleFoods"
            >
              <Tab eventKey={"all"} title="All" />
              <Tab eventKey={"unanswered"} title="Unanswered" />
            </Tabs>
          </div>
        </div>

        <FoodList
          foods={filteredFoods}
          updateFood={this.updateFood}
          canEdit={!!this.state.user}
        />

        <RewardFooter foods={foods} />
      </div>
    );
  }
}

export default App;



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/